import { THEME_COLORS, STATUS_COLORS, TONE_COLORS } from './colors';

/* --- From epbuy.ts --- */
export const EPBUY_COLORS = {
  ...THEME_COLORS,
  blue: STATUS_COLORS.blue,
  green: STATUS_COLORS.successAlt,
  gold: STATUS_COLORS.warning,
  red: STATUS_COLORS.error,
  info: STATUS_COLORS.info,
} as const;

/* --- From epsell.ts --- */
export type EpSellPaymentMethod = '銀行轉帳' | '微信' | '支付寶' | 'USDT';

export const EPSELL_COLORS = {
  ...THEME_COLORS,
  gold: STATUS_COLORS.warning,
  green: STATUS_COLORS.successAlt,
  red: STATUS_COLORS.error,
} as const;

// Re-export from common
export { EP_SELL_PAYMENT_METHODS as EPSELL_PAYMENT_METHODS } from './common';

/* --- From eptrading.ts --- */
export type EpTradingTabKey = 'hall' | 'my-sell' | 'my-buy' | 'dispute';
export type EpTradingTone = 'blue' | 'info' | 'green' | 'muted' | 'red';


export const EPTRADING_COLORS = {
  ...THEME_COLORS,
  blue: STATUS_COLORS.blue,
  green: STATUS_COLORS.successAlt,
  gold: STATUS_COLORS.warning,
  red: STATUS_COLORS.error,
  info: STATUS_COLORS.info,
} as const;

export const EPTRADING_TABS: { key: EpTradingTabKey; labelKey: string }[] = [
  { key: 'hall', labelKey: 'epTrading.hall' },
  { key: 'my-sell', labelKey: 'epTrading.mySell' },
  { key: 'my-buy', labelKey: 'epTrading.myBuy' },
  { key: 'dispute', labelKey: 'epTrading.dispute' },
];

export const EPTRADING_STATUS: Record<string, { labelKey: string; tone: EpTradingTone }> = {
  open: { labelKey: 'epTrading.statusOpen', tone: 'blue' },
  partial: { labelKey: 'epTrading.statusPartial', tone: 'info' },
  done: { labelKey: 'epTrading.statusDone', tone: 'green' },
  cancelled: { labelKey: 'epTrading.statusCancelled', tone: 'muted' },
  dispute: { labelKey: 'epTrading.statusDispute', tone: 'red' },
};

/* --- From ephub.ts --- */
export type EpHubAction = {
  labelKey: string;
  labelFallback: string;
  sublabelKey: string;
  sublabelFallback: string;
  route: string;
  icon: string;
  tone: 'blue' | 'green' | 'gold' | 'muted';
};

export type EpHubMarket = {
  titleKey: string;
  titleFallback: string;
  badge: string;
  tone: 'blue' | 'green';
  actions: EpHubAction[];
};

export type EpHubStat = {
  value: string;
  labelKey: string;
  labelFallback: string;
  tone: 'blue' | 'green' | 'gold';
  icon: string;
};


export const EPHUB_COLORS = {
  ...THEME_COLORS,
  heroTitle: THEME_COLORS.titleGradient,
  heroTitleShadow: '0 0 12px rgba(49,47,6,0.85)',
  statDivider: 'linear-gradient(180deg, transparent 0%, #ADD741 52.4%, transparent 100%)',
  tones: TONE_COLORS,
} as const;

export const EPHUB_STATS: EpHubStat[] = [
  { value: 'EP1', labelKey: 'epHub.cashPoints', labelFallback: '现金点数', tone: 'blue', icon: '/brand/ep-hub/ep-1.png' },
  { value: 'EP2', labelKey: 'epHub.cashPoints', labelFallback: '现金点数', tone: 'green', icon: '/brand/ep-hub/ep-2.png' },
];

export const EPHUB_MARKETS: EpHubMarket[] = [
  {
    titleKey: 'epHub.ep1Market',
    titleFallback: 'EP1 交易市场',
    badge: 'EP1',
    tone: 'blue',
    actions: [
      { labelKey: 'epHub.ep1Trading', labelFallback: 'EP1交易', sublabelKey: 'epHub.ep1TradingSub', sublabelFallback: '挂单撮合', route: '/ep-trading', icon: '/brand/ep-hub/ep-1-trading.png', tone: 'blue' },
      { labelKey: 'epHub.ep1Buy', labelFallback: 'EP1求购', sublabelKey: 'epHub.ep1BuySub', sublabelFallback: '发起求购', route: '/ep-buy', icon: '/brand/ep-hub/ep-1-buy.png', tone: 'green' },
      { labelKey: 'epHub.buyHistory', labelFallback: '求购记录', sublabelKey: 'epHub.buyHistorySub', sublabelFallback: '历史查询', route: '/ep-buy-history', icon: '/brand/ep-hub/ep-1-record.png', tone: 'muted' },
    ],
  },
  {
    titleKey: 'epHub.ep2Market',
    titleFallback: 'EP2 交易市场',
    badge: 'EP2',
    tone: 'green',
    actions: [
      { labelKey: 'epHub.ep2Trading', labelFallback: 'EP2交易', sublabelKey: 'epHub.ep2TradingSub', sublabelFallback: '挂单撮合', route: '/ep-trading?type=ep2', icon: '/brand/ep-hub/ep-1-trading.png', tone: 'green' },
      { labelKey: 'epHub.ep2Buy', labelFallback: 'EP2求购', sublabelKey: 'epHub.ep2BuySub', sublabelFallback: '发起求购', route: '/ep-buy?type=ep2', icon: '/brand/ep-hub/ep-1-buy.png', tone: 'gold' },
      { labelKey: 'epHub.buyHistory', labelFallback: '求购记录', sublabelKey: 'epHub.buyHistorySub', sublabelFallback: '历史查询', route: '/ep-buy-history?type=ep2', icon: '/brand/ep-hub/ep-1-record.png', tone: 'muted' },
    ],
  },
];
